import Helpers from '@helpers';
import * as React from 'react';
import OrderSummaryHelper from '../order-summary/order_summary';
import { Prop, State } from './model';
import './styles.css';

class Voucher extends React.Component<Prop, State> {
    constructor(props) {
        super(props);

        this.state = this.getInitialState();
    }

    public componentDidMount() {
        const code = this.getCodeHiddenFieldValue();
        if (code) {
            this.validateVoucher(code);
        }
        var input = document.getElementById('vocher-input')
        input.addEventListener("keypress", function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById('voucher-btn').click();
            }
        })
    }

    public componentDidUpdate() {
        if (this.isVoucherValid()) {
            OrderSummaryHelper.setVoucherDiscount(this.state.voucher.amount);
            $('#hfdVoucherCode').val(this.state.voucher.code);

        } else {
            OrderSummaryHelper.setVoucherDiscount(0);
            $('#hfdVoucherCode').val('');
        }
    }

    public render() {
        return (
            <div>
                <h2 className="order-page__header">
                    کد تخفیف
                </h2>
                <div className='voucher'>
                    <div style={{ display: this.isVoucherValid() ? 'none' : 'block' }}>
                        <p className='message tetx-gray font-weight-light'>
                            در صورتی که کد تخفیف برای این سفارش دارید آنرا ثبت نمائید.
                        </p>
                        <div className='voucher-form'>
                            <input id="vocher-input" type='text' onChange={this.handleChange}></input>
                            <button id="voucher-btn" className='btn btn-red text-fa-h4' onClick={this.submitVoucher}>
                                ثبت
                            </button>
                        </div>
                        <div className='alert-box alert-error errors voucher-error'
                            style={{ display: this.getErrorMessage() ? 'block' : 'none' }}>
                            {this.getErrorMessage()}
                        </div>
                    </div>
                    <div className='success-container' style={{ display: this.isVoucherValid() ? 'block' : 'none' }}>
                        <div className='voucher-success'>
                            <span>
                                تخفیف برای این سفارش اعمال شد.
                            </span>

                            <button className='btn-transparent text-fa-h4 voucher-remove-btn' onClick={this.removeVoucher}>
                                حذف
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private handleChange = event => {
        const inputValue = event.target.value;
        this.setState({
            inputValue
        });
    }

    private submitVoucher = e => {
        if (this.state.inputValue) {
            this.validateVoucher(this.state.inputValue);
        }

        e.preventDefault();
    }

    private removeVoucher = e => {
        this.setState({
            voucher: null
        });

        e.preventDefault();
    }

    private validateVoucher = (code: string) => {
        Helpers.LoadingHelper.showLoading();
        Helpers.ApiHelper.validateVoucher(code).then(voucher => {
            this.setState({
                voucher
            });

            Helpers.LoadingHelper.hideLoading();
        });
    }

    private isVoucherValid = (): boolean =>
        this.state.voucher &&
        !this.state.voucher.errorMessage &&
        this.state.voucher.amount > 0

    private getErrorMessage = (): string => {
        if (this.state.voucher &&
            this.state.voucher.errorMessage &&
            this.state.voucher.errorMessage.length > 0) {
            return this.state.voucher.errorMessage;
        }

        return null;
    }

    private getInitialState = (): State => ({
        voucher: null,
        errorMessage: null,
        inputValue: null
    })

    private getCodeHiddenFieldValue = () => {
        const value = $('#hfdVoucherCode').val().toString();
        return value.length > 0 ? value : null;
    }
}

Helpers.ReactHelper.createReactElement('Voucher', Voucher);
